import { useState, useEffect } from "react";
import { loadJobLevelList } from "../services/humanResourceServices";

const useJobLevelList = (defaultSelectedID = null) => {

    const [jobLevel, seJobLevel] = useState([]);
    const [selectedJobLevel, setSelectedJobLevel] = useState(null);
    const [jobLevelID, setJobLevelID] = useState(null);
    const [isJobLevelDataLoaded, setIsJobLevelDataLoaded] = useState(false);

    const fetchEmployee = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadJobLevelList(para);
            if (data && data.length > 0) {
                seJobLevel(data);

                const initial = selectedID
                    ? data.find((e) => e.id === selectedID)
                    : [];

                if (initial) {
                    setSelectedJobLevel(initial);
                    setJobLevelID(initial.id);
                }

                setIsJobLevelDataLoaded(true);
            }
        } catch (error) {
            console.error("Failed to load employee list:", error);
        }
    };

    useEffect(() => {
        if (!isJobLevelDataLoaded) {
            fetchEmployee(defaultSelectedID);
        }
    }, [defaultSelectedID, isJobLevelDataLoaded]);

    const loadJobLevelByID = async (selectedID) => {
        await fetchEmployee(selectedID);
    };

    return {
        jobLevel,
        selectedJobLevel,
        jobLevelID,
        setSelectedJobLevel,
        setJobLevelID,
        loadJobLevelByID,
    };
};

export default useJobLevelList;
